<template>
    <v-layout class="component-wrap">
        <Favourites />
    </v-layout>
</template>

<script>
import Favourites from '@/components/view_blocks/Favourites/Favourites_wrap';

export default {
  components: {
    Favourites,
  },
};
</script>
